// extracted by mini-css-extract-plugin
export default {"container":"map-org_container__DjiHC","left":"map-org_left__0HESX","right":"map-org_right__iQx76"};